import { GeneratorsUtility } from '../utilities/generators';
import { WordDataTypeEnum } from './enums/word-data-type.enum';
import { ClassificationParameterTypeEnum } from './interfaces/classification-parameters.interface';
import { IGroupConfiguration, IGroupConfigurationKey, IGroupTableConfiguration } from './interfaces/group-keys.interface';

/**
 * Representa o conjunto de configurações para extração de dados de um robô (word clicks).
 * @todo Refatorar nomes. Ao invés de grupo de configurações, iremos chamar de tipo de documento.
 */
export class GroupConfiguration implements IGroupConfiguration {
  public readonly id: string;
  public robotId: string;
  public name: string;
  public keys: GroupConfigurationKey[];
  public state = {};
  public type: ClassificationParameterTypeEnum = ClassificationParameterTypeEnum.ocr;

  constructor(
    robotId: string,
    name: string,
    keys: GroupConfigurationKey[],
    id?: string,
    state?: { [key: string]: any },
    type?: ClassificationParameterTypeEnum
  ) {
    this.id = id || GeneratorsUtility.generateGUID();
    this.robotId = robotId;
    this.name = name;
    this.keys = keys;

    if (state) {
      this.state = state;
    }

    if (type) {
      this.type = type;
    }
  }
}

/**
 * Representa a configuração de um campo exibido de um tipo de documento para extração do robô (word click).
 * @todo Refatorar nomes. Ao invés de grupo de configurações, iremos chamar de tipo de documento.
 */
export class GroupConfigurationKey implements IGroupConfigurationKey {
  public key: string;
  public type: WordDataTypeEnum;
  public label: string;
  public isCustom? = false;
  public required? = false;
  public canReceiveConstant? = false;
  public description?: string;
  public regex?: string;
  public landmarks?: any[];
  public tableConfiguration?: IGroupTableConfiguration;

  constructor(key: IGroupConfigurationKey) {
    Object.assign(this, key);
  }
}
